const HoraireInformationsStyle = theme => ({
  dayLabel: {
    marginTop: "1rem",
    color: theme.palette.common.black,
    fontFamily: theme.typography.fontFamily
  }
});

export default HoraireInformationsStyle;
